module.exports = __webpack_public_path__ + "static/media/YDJSPserie.8126f96e.jpg";